/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DanceActivityFeedItem } from './DanceActivityFeedItem';
import {
    DanceActivityFeedItemFromJSON,
    DanceActivityFeedItemFromJSONTyped,
    DanceActivityFeedItemToJSON,
    DanceActivityFeedItemToJSONTyped,
} from './DanceActivityFeedItem';

/**
 * 
 * @export
 * @interface ResultOfIReadOnlyListOfDanceActivityFeedItem
 */
export interface ResultOfIReadOnlyListOfDanceActivityFeedItem {
    /**
     * 
     * @type {Array<DanceActivityFeedItem>}
     * @memberof ResultOfIReadOnlyListOfDanceActivityFeedItem
     */
    data: Array<DanceActivityFeedItem> | null;
    /**
     * 
     * @type {boolean}
     * @memberof ResultOfIReadOnlyListOfDanceActivityFeedItem
     */
    isSuccess: boolean;
    /**
     * 
     * @type {Error}
     * @memberof ResultOfIReadOnlyListOfDanceActivityFeedItem
     */
    error: Error | null;
}

/**
 * Check if a given object implements the ResultOfIReadOnlyListOfDanceActivityFeedItem interface.
 */
export function instanceOfResultOfIReadOnlyListOfDanceActivityFeedItem(value: object): value is ResultOfIReadOnlyListOfDanceActivityFeedItem {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('isSuccess' in value) || value['isSuccess'] === undefined) return false;
    if (!('error' in value) || value['error'] === undefined) return false;
    return true;
}

export function ResultOfIReadOnlyListOfDanceActivityFeedItemFromJSON(json: any): ResultOfIReadOnlyListOfDanceActivityFeedItem {
    return ResultOfIReadOnlyListOfDanceActivityFeedItemFromJSONTyped(json, false);
}

export function ResultOfIReadOnlyListOfDanceActivityFeedItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfIReadOnlyListOfDanceActivityFeedItem {
    if (json == null) {
        return json;
    }
    return {
        
        'data': (json['data'] == null ? null : (json['data'] as Array<any>).map(DanceActivityFeedItemFromJSON)),
        'isSuccess': json['isSuccess'],
        'error': json['error'],
    };
}

export function ResultOfIReadOnlyListOfDanceActivityFeedItemToJSON(json: any): ResultOfIReadOnlyListOfDanceActivityFeedItem {
    return ResultOfIReadOnlyListOfDanceActivityFeedItemToJSONTyped(json, false);
}

export function ResultOfIReadOnlyListOfDanceActivityFeedItemToJSONTyped(value?: ResultOfIReadOnlyListOfDanceActivityFeedItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': (value['data'] == null ? null : (value['data'] as Array<any>).map(DanceActivityFeedItemToJSON)),
        'isSuccess': value['isSuccess'],
        'error': value['error'],
    };
}

